export default function Contact() {
  return <h3>Contact</h3>;
}
